import { Popover, PopoverContent, PopoverTrigger } from "@babackapp/ui/components/popover";
import { LayoutGridIcon } from "lucide-react";
import { postToParent } from "../lib/shop-now-embed";

type WidgetPos = "center" | "n" | "ne" | "e" | "se" | "s" | "sw" | "w" | "nw";

const GRID: WidgetPos[][] = [
  ["nw", "n",      "ne"],
  ["w",  "center", "e" ],
  ["sw", "s",      "se"],
];

export function PositionSelector() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex items-center justify-center size-7 rounded-md bg-black/10 hover:bg-black/20 transition-colors cursor-pointer">
          <LayoutGridIcon className="size-3.5 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-auto p-2">
        <div className="grid grid-cols-3 gap-1">
          {GRID.flat().map((pos) => (
            <button
              key={pos}
              onClick={() => postToParent({ type: "WIDGET_SET_POSITION", position: pos })}
              title={pos}
              className="size-8 rounded flex items-center justify-center bg-muted hover:bg-primary/20 transition-colors cursor-pointer"
            >
              <div className="size-2.5 rounded-sm bg-foreground opacity-40" />
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
